import { createSelector } from 'reselect'

import { areEqualObjects } from 'redux/selectors/helpers/comparison'

const drawItSelector = state => state.drawIt
const uiSelector = state => state.ui

const drawItSaveSelector = createSelector(
	[ drawItSelector, uiSelector ],
	drawItState => {
		/* This is to know if the transformations made to the image are equal to the transformations that came from CT */
		const isEqualTransformation = areEqualObjects(drawItState.iconBackground.transformations, drawItState.iconBackgroundInitialTransformations)
		/* We send to CT a param: isModified, to process the image or not if something changed, the main reason is to avoid unnecesary processing
									 on the server side.
			Important note: when the image is uploaded to CT, the image is processed and the default params are set.
				Then we need to check:
				1st condition. If param type is an image, type should be 'image' (It prevents if is not an image, or image was not loaded)
				2nd condition. If the image is the same image that came from CT, only true if changes were made.
		*/
		const isModified = drawItState.iconBackground.type === 'image' && !isEqualTransformation
		return {
			entityUID: drawItState.entityUID,
			allIconsDone: drawItState.icon.status !== 'uploading' && drawItState.iconBackground.status !== 'uploading',
			instructions: drawItState.instructions,
			iconId: drawItState.icon.id,
			iconBackgroundId: drawItState.iconBackground.id,
			presentationId: drawItState.presentationId,
			isFlippedHorizontally: drawItState.iconBackground.transformations.isFlippedHorizontally,
			isFlippedVertically: drawItState.iconBackground.transformations.isFlippedVertically,
			scale: drawItState.iconBackground.transformations.scale.toString(),
			rotatedDegrees: drawItState.iconBackground.transformations.rotation,
			isModified,
			offsetX: drawItState.iconBackground.transformations.offsetX,
			offsetY: drawItState.iconBackground.transformations.offsetY,
		}
	}
)

export default drawItSaveSelector
